import { useState } from "react";
import { Download } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
const { REACT_APP_BASE_URL } = process.env;

const SingleVideoDownloadDropdown = ({ DownloadDropdownData }) => {
  const [videoDownloading, setVideoDownloading] = useState(false);

  const [campaignDropdown, setCampaignDropdown] = useState(false);
  const [showSubmenu, setShowSubmenu] = useState(false);

  const video = useSelector(
    (state) => state.videoAssociations.body.video || {}
  );

  const transcript = useSelector((state) => state.transcript);
  // console.log(transcript)
  const toggleDropdown = () => {
    setCampaignDropdown(!campaignDropdown);
    if (!campaignDropdown) {
      setShowSubmenu(false);
    }
  };

  const hasTranscription = (videoId) => {
    const video = transcript?.transcripts.find(
      (video) => video.video_id === videoId
    );
    return video ? video.transcription.length > 0 : false;
  };

  const toggleSubmenu = () => {
    setShowSubmenu(true);
  };

  const toggleSubmenuClose = () => {
    setShowSubmenu(false);
  };

  const handleDownloadReport = async (fileType) => {
    const body = {
      report_type: "all_transcripts",
      video_id: video?._id,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    const config = { method: "POST", body: JSON.stringify(body), headers };

    try {
      const response = await fetch(
        `${REACT_APP_BASE_URL}/jwt_api/videos/download_transcript_report.${fileType}`,
        config
      );

      if (!response.ok) {
        throw new Error("Failed to fetch the report. Please try again later.");
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      // Use the File System Access API to get a directory handle
      if ("showDirectoryPicker" in window) {
        try {
          const dirHandle = await window.showDirectoryPicker();
          const fileHandle = await dirHandle.getFileHandle(
            `campaign-transcript.${fileType}`,
            { create: true }
          );
          const writableStream = await fileHandle.createWritable();
          setVideoDownloading(true); // Set loading indicator after directory is chosen
          await writableStream.write(blob);
          await writableStream.close();
          // alert('Download successful!');
        } catch (dirError) {
          if (dirError.name === "AbortError") {
            console.log("Directory picker was cancelled.");
          } else {
            throw dirError;
          }
        }
      } else {
        setVideoDownloading(true); // Set loading indicator for non-File System Access API case
        const link = document.createElement("a");
        link.href = url;
        link.download = `campaign-transcript.${fileType}`;
        link.setAttribute("type", "hidden");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error during the download process:", err);
      alert("Error during download. Please try again.");
    } finally {
      setVideoDownloading(false);
    }
  };

  const handleSaveVideoAs = async (videoUrl) => {
    try {
      const fileHandle = await getSaveFilePicker();
      await save(fileHandle, videoUrl);
    } catch (error) {
      console.error("Error downloading the video:", error);
    } finally {
      setVideoDownloading(false);
    }
  };

  const getSaveFilePicker = async () => {
    const opts = {
      suggestedName: video?.title,
      types: [
        {
          accept: { "video/mp4": [".mp4"] },
        },
      ],
    };
    return window.showSaveFilePicker(opts);
  };

  const save = async (fileHandle, url) => {
    setVideoDownloading(true);
    try {
      const writable = await fileHandle.createWritable();
      const response = await fetch(url);
      const videoBlob = await response.blob();
      await writable.write(videoBlob);
      await writable.close();
    } catch (error) {
      console.error("Error saving the video:", error);
    }
  };

  return (
    <ButtonDropdown
      className="download-list"
      isOpen={campaignDropdown}
      toggle={videoDownloading ? () => {} : toggleDropdown}
    >
      <DropdownToggle outline color="#000000" className="toogle-btn">
        <div className="download-btn-container">
          <div>
            {videoDownloading ? (
              <Spinner />
            ) : (
              <Download size={27} color="#783AD0" strokeWidth={1} />
            )}
          </div>

          <div className="title">
            {videoDownloading ? "Downloading" : "Download"}
          </div>
        </div>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu">
        <DropdownItem
          onMouseEnter={toggleSubmenuClose}
          onClick={() => handleSaveVideoAs(video?.video_url)}
        >
          Video
        </DropdownItem>
        {hasTranscription(video?._id) && (
          <>
            <DropdownItem divider />
            <DropdownItem onMouseEnter={toggleSubmenu}>
              Transcript
              <img
                height={9}
                src={require("@images/videos/expand-right-icon.png").default}
              />
            </DropdownItem>
          </>
        )}
      </DropdownMenu>

      <div className="download-list-sub-menu">
        {showSubmenu && (
          <DropdownMenu className="dropdown-menu">
            <DropdownItem onClick={() => handleDownloadReport("txt")}>
              txt
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => handleDownloadReport("pdf")}>
              pdf
            </DropdownItem>
          </DropdownMenu>
        )}
      </div>
    </ButtonDropdown>
  );
};

export default SingleVideoDownloadDropdown;